var _defs, _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 78.3,
    y1: 14.3,
    x2: 59.2,
    y2: 37.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1bc36f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1bc36f",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 83.2,
    y1: 36.7,
    x2: 23.5,
    y2: 60.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2060cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4e3fa"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g3",
    cx: 29.3,
    cy: 77.8,
    r: 13.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0458e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12408e"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#g1)}.b{fill:url(#g2)}.c{fill:url(#g3)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m83.2 27.5l-17.2-17.5v17.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b",
    d: "m83.2 27.8v51.2c0 6.9-1.5 8.6-8.7 8.6h-51v-69c0-6.9 1.6-8.6 8.7-8.6h33.8zm-51.3-5.6q0 0.3 0.1 0.5 0.1 0.2 0.3 0.4 0.1 0.2 0.4 0.2 0.2 0.1 0.4 0.1h23.6c0.3 0 0.7-0.1 0.9-0.3 0.2-0.2 0.3-0.6 0.3-0.9 0-0.3-0.1-0.6-0.3-0.8-0.2-0.3-0.6-0.4-0.9-0.4h-23.6c-0.7 0-1.3 0.6-1.2 1.2zm0 11q0 0.3 0.1 0.5 0.1 0.2 0.3 0.4 0.1 0.2 0.4 0.2 0.2 0.1 0.4 0.1h23.6c0.3 0 0.7-0.1 0.9-0.3 0.2-0.3 0.3-0.6 0.3-0.9 0-0.3-0.1-0.6-0.3-0.8-0.2-0.3-0.6-0.4-0.9-0.4h-23.6c-0.7 0-1.3 0.6-1.2 1.2zm44 11.9c0.3-0.2 0.4-0.5 0.5-0.9q0-0.2-0.1-0.4-0.1-0.3-0.3-0.4-0.2-0.2-0.4-0.3-0.2-0.1-0.5-0.1h-42c-0.3 0-0.6 0.1-0.8 0.4-0.3 0.2-0.4 0.5-0.4 0.8 0 0.3 0.1 0.6 0.4 0.9 0.2 0.2 0.5 0.3 0.8 0.3h41.9c0.3 0 0.7-0.1 0.9-0.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m34.1 66.5c1.4 0.6 2.8 1.5 4 2.7 1.1 1.1 2 2.4 2.6 3.9 0.6 1.5 1 3.1 1 4.7 0 2.4-0.8 4.8-2.1 6.8-1.4 2-3.3 3.5-5.6 4.5-2.2 0.9-4.7 1.1-7.1 0.7-2.4-0.5-4.6-1.7-6.3-3.4-1.7-1.7-2.9-3.9-3.4-6.2-0.4-2.4-0.2-4.8 0.7-7.1 1-2.2 2.6-4.1 4.6-5.4 2-1.4 4.4-2.1 6.8-2.1 1.6 0 3.3 0.3 4.8 0.9zm1.8 11.3q0-0.2-0.1-0.4-0.1-0.1-0.2-0.3-0.1-0.1-0.3-0.1-0.2-0.1-0.3-0.1h-4.8v-4.7q0-0.3-0.2-0.6-0.3-0.3-0.7-0.3-0.3 0-0.6 0.3-0.3 0.3-0.3 0.6v4.7h-4.7q-0.4 0-0.6 0.3-0.3 0.2-0.3 0.6 0 0.4 0.3 0.6 0.2 0.3 0.6 0.3h4.7v4.7q0 0.3 0.3 0.6 0.3 0.3 0.6 0.3 0.4 0 0.7-0.3 0.2-0.3 0.2-0.6v-4.7h4.8c0.4 0 0.7-0.5 0.9-0.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.f59cb20469b89190f0555da126edefba.svg";
export { ForwardRef as ReactComponent };